/** Mask dollar figures for employees who can't see money (spec: money gate). */
export function maskMoney(text: string, canSeeMoney: boolean): string {
    return canSeeMoney ? text : text.replace(/\$\s?[\d,]+(?:\.\d{2})?/g, "$•••");
}
